var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","overlay-opacity":80,"width":"400"},model:{value:(_vm.loginchallenge),callback:function ($$v) {_vm.loginchallenge=$$v},expression:"loginchallenge"}},[_c('login-session',{on:{"loggedin":function($event){_vm.loginchallenge=false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }